import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Container, Avatar } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <Avatar sx={{ width: 120, height: 120, bgcolor: 'error.15', color: 'error.main', mb: 3 }}>
          <ErrorOutlineIcon sx={{ fontSize: 80 }} />
        </Avatar>
        <Typography variant="h1" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: -4, mb: 1 }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary', mb: 2 }}>
          Signal Lost
        </Typography>
        <Typography variant="body1" sx={{ mb: 5, color: 'text.secondary', fontWeight: 500, maxWidth: '400px' }}>
          The requested coordinate does not exist in our telemetry mesh. It may have been decommissioned or moved.
        </Typography>
        <Button
          variant="contained"
          className="gradient-primary"
          component={Link}
          to="/"
          size="large"
          sx={{ px: 6, py: 1.5, borderRadius: '14px', fontWeight: 800, textTransform: 'none', fontSize: '16px' }}
        >
          Return to Mission Control
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;